/** Can be use to synchronize an asynchronous operation to prevent parallel execution. */
export class Lock {
    get isLocked() {
        return (this.mCurrentRunningTasks >= this.mMaxConcurrentTasks);
    }
    constructor(pMaxConcurrentTasks = 1) {
        this.onUnlock = (pAsync = false) => {
            this.mCurrentRunningTasks--;
            if (pAsync) {
                setTimeout(() => {
                    this.resolveNext();
                });
            }
            else {
                this.resolveNext();
            }
        };
        this.mMaxConcurrentTasks = pMaxConcurrentTasks;
        this.mCurrentRunningTasks = 0;
        this.mPromiseQueue = [];
        this.mLockContext = {
            unlock: this.onUnlock
        };
        this.mWaitPromise = null;
        this.mWaitPromiseResolve = null;
    }
    acquireLock() {
        const tPromise = new Promise((resolve, reject) => {
            this.mPromiseQueue.push(resolve);
        });
        this.resolveNext();
        return (tPromise);
    }
    waitWhileLocked() {
        if (this.isLocked) {
            if (this.mWaitPromise == null) {
                this.mWaitPromise = new Promise((resolve, reject) => {
                    this.mWaitPromiseResolve = resolve;
                });
            }
            return (this.mWaitPromise);
        }
        else {
            return (Promise.resolve());
        }
    }
    resolveNext() {
        if (!this.isLocked) {
            this.resolveWaitPromise();
            const tResolve = this.mPromiseQueue.shift();
            if (tResolve !== undefined) {
                this.mCurrentRunningTasks++;
                tResolve(this.mLockContext);
            }
        }
    }
    resolveWaitPromise() {
        if (this.mWaitPromiseResolve != null) {
            this.mWaitPromise = null;
            this.mWaitPromiseResolve();
            this.mWaitPromiseResolve = null;
        }
    }
}
export default Lock;
